import axios from 'axios';
import { IReportBenchmark_Port, IReportBenchmarkMOU } from '../contracts/report-benchmark.contract';
import ConfigService from './config.service';

const getBenchmarkReport = async (startDate: Date, endDate: Date ,moUs: string[] = [], vesselTypes: string[] = [], ports: string[] = []): Promise<IReportBenchmarkMOU[]> => {
    const res = await axios.post(`${ConfigService.appConfig.baseApiUrl}/RptBenchmark/GetBenchmarkReport`, {
        startDate: startDate,
        endDate: endDate,
        moUs,
        vesselTypes,
        ports
    });

    return res.data;
};

const getVesselTypes = async (): Promise<string[]> => {
    const res = await axios.get(`${ConfigService.appConfig.baseApiUrl}/RptBenchmark/GetVesselTypes`);
    return res.data;
};

const getMOUs = async (): Promise<string[]> => {
    const res = await axios.get(`${ConfigService.appConfig.baseApiUrl}/RptBenchmark/GetMOUs`);
    return res.data;
};

const getPorts = async (): Promise<IReportBenchmark_Port[]> => {
    const res = await axios.post(`${ConfigService.appConfig.baseApiUrl}/RptBenchmark/GetPorts`, {
        MOU: []
    });
    return res.data;
};

const BenchmarkService = {
    getBenchmarkReport,
    getVesselTypes,
    getMOUs,
    getPorts
};

export default BenchmarkService;
